import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    // NOTE: "Meet The Team" data removed per Khalil's request (2026-05-29).
    // Kept here to re-add later once real team members are ready.
    // const teamMembers = [
    //     {
    //         name: 'Your Name Here',
    //         role: 'Founder & CEO',
    //         bio: 'Placeholder bio - Describe your background, experience, and passion for technology and business.'
    //     },
    //     {
    //         name: 'Team Member Name',
    //         role: 'Lead Developer',
    //         bio: 'Placeholder bio - Describe their expertise and contributions to the team.'
    //     },
    //     {
    //         name: 'Team Member Name',
    //         role: 'Business Consultant',
    //         bio: 'Placeholder bio - Describe their expertise and contributions to the team.'
    //     }
    // ];

    const values = [
        {
            icon: '🎯',
            title: 'Excellence',
            description: 'We strive for excellence in everything we do, delivering solutions that exceed expectations.'
        },
        {
            icon: '🤝',
            title: 'Integrity',
            description: 'We operate with transparency and honesty, building lasting relationships with our clients.'
        },
        {
            icon: '🚀',
            title: 'Innovation',
            description: 'We embrace new technologies and creative approaches to solve complex challenges.'
        },
        {
            icon: '💪',
            title: 'Commitment',
            description: 'We are dedicated to our clients\' success and go above and beyond to deliver results.'
        }
    ];

    return (
        <div className="page">
            {/* Hero Section */}
            <section className="page-hero">
                <div className="page-hero-content container">
                    <h1>About <span className="text-gradient">OnOneGroup</span></h1>
                    <p>
                        {/* PLACEHOLDER: Update with your company story intro */}
                        We're a passionate team of technologists and consultants dedicated to helping
                        businesses succeed in the digital age.
                    </p>
                </div>
            </section>

            {/* Story Section */}
            <section className="section">
                <div className="container">
                    <div className="about-content" style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <h2 className="mb-lg">Our <span className="text-gradient">Story</span></h2>
                        {/* PLACEHOLDER: Update with your actual company story */}
                        <p className="text-muted mb-lg" style={{ fontSize: '1.125rem', lineHeight: '1.8' }}>
                            OnOneGroup was founded with a simple mission: to bridge the gap between
                            technology and business success. We recognized that many businesses struggle
                            to leverage technology effectively, and we set out to change that.
                        </p>
                        <p className="text-muted mb-lg" style={{ fontSize: '1.125rem', lineHeight: '1.8' }}>
                            Today, we offer a comprehensive suite of services spanning web development,
                            IT consulting, software solutions, app development, and investment consulting
                            in real estate and traditional markets.
                        </p>
                        <p className="text-muted" style={{ fontSize: '1.125rem', lineHeight: '1.8' }}>
                            Our team combines deep technical expertise with business acumen to deliver
                            solutions that drive real results for our clients.
                        </p>
                    </div>
                </div>
            </section>

            {/* Mission & Vision */}
            <section className="section bg-dark">
                <div className="container">
                    <div className="services-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))' }}>
                        <div className="card card-gradient">
                            <h3 className="mb-md">🎯 Our Mission</h3>
                            {/* PLACEHOLDER: Update with your mission */}
                            <p className="text-muted">
                                To empower businesses with innovative technology solutions and strategic
                                insights that drive growth, efficiency, and competitive advantage in an
                                ever-evolving digital landscape.
                            </p>
                        </div>
                        <div className="card card-gradient">
                            <h3 className="mb-md">🔭 Our Vision</h3>
                            {/* PLACEHOLDER: Update with your vision */}
                            <p className="text-muted">
                                To become the trusted partner of choice for businesses seeking to
                                harness the power of technology and smart investments to achieve
                                their full potential.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Values</span></h2>
                        <p>The principles that guide everything we do</p>
                    </div>
                    <div className="features-grid">
                        {values.map((value, index) => (
                            <div key={index} className="feature-item">
                                <div className="feature-icon">{value.icon}</div>
                                <div className="feature-content">
                                    <h4>{value.title}</h4>
                                    <p>{value.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/*
              NOTE: "Meet The Team" section removed per Khalil's request (2026-05-29).
              Keep this block (and the teamMembers array above) to re-add later
              once real team members are ready.

            <section className="section bg-dark">
                <div className="container">
                    <div className="section-header">
                        <h2>Meet The <span className="text-gradient">Team</span></h2>
                        <p>The talented people behind OnOneGroup</p>
                    </div>
                    <div className="services-grid">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="card card-gradient text-center">
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)',
                                        margin: '0 auto 1.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2.5rem'
                                    }}
                                >
                                    👤
                                </div>
                                <h3 style={{ marginBottom: '0.5rem' }}>{member.name}</h3>
                                <p className="text-gradient" style={{ marginBottom: '1rem', fontWeight: '600' }}>
                                    {member.role}
                                </p>
                                <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                                    {member.bio}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            */}

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Let's Work Together</h2>
                            <p>
                                Ready to take your business to the next level? We'd love to hear from you.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Get In Touch →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
